<template>
     <div class="relative overflow-hidden">
        <h3 class="absolute text-sm md:text-lg top-2 left-4 md:top-10 md:left-10 font-semibold uppercase text-teal-500 font-sans">Contact</h3>
        <div class="box-content relative flex flex-col md:flex-row justify-center gap-4 md:px-[40px] lg:px-[100px]">
            <div data-aos="fade-up" data-aos-duration="1000" class="relative z-10 py-[8px] md:px-8 md:py-4 text-center my-auto mx-auto mx-md-0">
                <h3 class="text-orange-900 uppercase font-normal text-2xl sm:text-4xl md:text-5xl mb-0">Liên hệ với HUET</h3>
                <p class="text-justify mb-3 md:mt-3 md:mb-6 font-light text-md sm:text-lg md:text-xl"><i>
                    Đây là nơi bạn có thể tìm thấy thông tin cần thiết để liên hệ với HUET. Nếu bạn quan tâm hoặc bất cứ thắc 
                    mắc liên quan đến việc học tập tại HUET, bạn có thể liên hệ trực tiếp với phòng Tư vấn tuyển sinh để 
                    được hỗ trợ và giải đáp các thắc mắc liên quan đến quy trình tuyển sinh. Ngoài ra, tại đây cũng 
                    cung cấp thông tin về địa chỉ, số điện thoại và email của các phòng ban trong trường, giúp bạn tiếp cận 
                    và liên lạc với HUET một cách dễ dàng và thuận tiện.
                </i></p>
            </div>
            <div data-aos="fade-right" data-aos-duration="1500" class="absolute z-0 top-4 left-[0px] lg:left-12 hidden md:block">
                <h3 class="text-transparent text-7xl md:text-[150px] lg:text-[200px] text-center font-outline-4">HUET</h3>
            </div>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 box-content text-black relative z-10 overflow-hidden md:px-[40px] lg:px-[100px] pt-0">
            <div class="min-h-[250px] order-2 md:order-1">
                <iframe :src="currentMaps" class="w-full h-full rounded-xl border-[1px] border-gray-400" allowfullscreen="" 
                        loading="lazy" referrerpolicy="no-referrer-when-downgrade">
                </iframe>
            </div>
            <div class="flex flex-col gap-4 sm:py-8 order-1 md:order-2">
                <div v-for="(item, index) in config.config.position" :key="index" @click="changeMaps(item)" class="contact-text">
                    <i class='bx bx-sm my-auto bx-current-location' ></i>
                    <p class="my-auto text-xl">{{ item.address }}</p>
                </div>
                <h3 class="contact-text" v-for="(item, index) in config.config.phone" :key="index">
                    <i class='bx bx-sm my-auto bxs-phone' ></i>
                    <p class="my-auto text-xl">{{ item.value }}</p>
                </h3>
                <a :href="'mailto:' + config.config.email" class="contact-text">
                    <i class='bx bx-sm my-auto bxs-envelope' ></i>
                    <p class="my-auto text-xl">{{ config.config.email }}</p>
                </a>
                <a target="_blank" :href="config.config.facebook" class="contact-text">
                    <i class='bx bx-sm my-auto bxl-facebook-circle' ></i>
                    <p class="my-auto text-xl">Khoa Kỹ Thuật và Công Nghệ</p>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'contact',
    props: {
        config: Object
    },
    data() {
        return {
            currentMaps: ''
        }
    },
    methods: {
        changeMaps(item) {
            this.currentMaps = item.maps
        }
    },
    created() {
        this.currentMaps = this.config.config.position[0].maps
    }
}
</script>
